var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListAddGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7718 5H3.07016C2.53008 5 2 5.32 2 6.07C2 6.71 2.43007 7.14 3.07016 7.14H13.7718C14.4119 7.14 14.842 6.71 14.842 6.07C14.842 5.43 14.4119 5 13.7718 5ZM13.7718 9.70999H3.07016C2.53008 9.70999 2 10.14 2 10.78C2 11.42 2.43007 11.84 3.07016 11.85H13.7718C14.4119 11.85 14.842 11.42 14.842 10.78C14.842 10.14 14.4119 9.70999 13.7718 9.70999ZM3.07016 14.63H9.49115C10.1313 14.63 10.5613 15.06 10.5613 15.7C10.5613 16.34 10.1313 16.77 9.49115 16.77H3.07016C2.43007 16.77 2 16.34 2 15.7C2 14.95 2.53008 14.63 3.07016 14.63ZM18.7925 14.63H20.9329C21.573 14.63 22.003 15.06 22.003 15.7C22.003 16.34 21.573 16.77 20.9329 16.77H18.7925V18.91C18.7925 19.55 18.3625 19.98 17.7224 19.98C17.0823 19.98 16.6522 19.55 16.6522 18.91V16.77H14.5119C13.8718 16.77 13.4417 16.34 13.4417 15.7C13.4417 15.06 13.9818 14.63 14.5119 14.63H16.6522V12.49C16.6522 11.85 17.0823 11.42 17.7224 11.42C18.3625 11.42 18.7925 11.96 18.7925 12.49V14.63Z",
    fill: "#E1C561"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListAddGold);
export default __webpack_public_path__ + "static/media/Icon-List-Add-Gold.bcf2fbaf.svg";
export { ForwardRef as ReactComponent };